import React from 'react';
import { Button } from './ui/button';
import { useAccessibility } from '../contexts/AccessibilityContext';

// Skip navigation component for accessibility
const SkipNavigation = () => {
  const { skipToMain } = useAccessibility();

  return (
    <Button
      onClick={skipToMain}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          skipToMain();
        }
      }}
      className="absolute -top-10 left-2 z-[9999] px-4 py-2 text-sm font-semibold focus:top-2 focus:outline-2 focus:outline-offset-2 focus:outline-yellow-500"
      tabIndex={1}
    >
      Skip to main content
    </Button>
  );
};

export default SkipNavigation;
